import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function getAddresses(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getAddresses()');
    invariant(brandId, 'brandId is a required param of getAddresses()');
    invariant(country, 'country is a required param of getAddresses()');
    invariant(uberToken, 'uberToken is a required param of getAddresses()');
    invariant(clientId, 'clientId is a required param of getAddresses()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contact`;

    return labelRequest(authenticatedRequest(new Request(url, { headers }), uberToken, clientId, clientSecret), 'getAddresses');
}
